$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');

  if (p === 'supply_list') {
    let orderBy = 'name';
    let orderByDirection = 'asc';
    let page = 1;
    $('select').select2({
      theme: 'bootstrap4',
    });

    //datepicker initialization
    $('#start-date').datepicker({
      dateFormat: 'dd-mm-yy',
    });
    $('#end-date').datepicker({
      dateFormat: 'dd-mm-yy',
    });

    $(document).on(
      'change',
      '#start-date, #end-date, #location-id',
      function () {
        const $form = $('#supply-list-filter-form');
        if ($form.length) {
          $form.trigger('submit');
        }
      }
    );

    $(document).on('click', '.sort', function (e) {
      e.preventDefault();

      const $th = $(this);
      const $table = $th.closest('table');
      const orderBy = $th.data('order-by');
      let orderByDirection = $th.data('order-by-direction') || 'desc';

      // **FIX 1**: Toggle direction BEFORE updating other headers
      orderByDirection = orderByDirection === 'asc' ? 'desc' : 'asc';

      // ─── Reset ALL headers (including current one) ───
      $th
        .closest('tr')
        .find('.sort')
        .each(function () {
          $(this)
            .data('order-by-direction', 'desc')
            .attr('data-order-by-direction', 'desc')
            .find('.material-icons')
            .text('sort')
            .removeClass('material-icons-asc');
        });

      // ─── Update ONLY current header with new direction ───
      $th
        .data('order-by-direction', orderByDirection)
        .attr('data-order-by-direction', orderByDirection);

      $th.siblings('.sort').each(function () {
        $(this).attr('data-order-by-direction', 'asc');
        const $otherIcon = $(this).find('.material-icons');
        $otherIcon
          .addClass('d-none')
          .removeClass('material-icons-asc')
          .text('sort');
      });

      // Update current header
      $th.attr('data-order-by-direction', orderByDirection);
      const $icon = $th.find('.material-icons');
      $icon.removeClass('d-none').text('sort');
      if (orderByDirection === 'asc') {
        $icon.addClass('material-icons-asc');
      } else {
        $icon.removeClass('material-icons-asc');
      }

      // Rest of your sorting code stays the same...
      const columnMap = {
        name: 0,
        sku: 1,
        total_quantity: 2,
      };

      const colIdx = columnMap[orderBy];
      if (colIdx === undefined) return;

      const $tbody = $table.find('tbody');
      const $rows = $tbody.find('tr').get();

      $rows.sort(function (a, b) {
        const $aTd = $(a).children('td').eq(colIdx);
        const $bTd = $(b).children('td').eq(colIdx);

        let aVal = $aTd.text().trim();
        let bVal = $bTd.text().trim();

        if (orderBy === 'total_quantity') {
          aVal = parseFloat(aVal) || 0;
          bVal = parseFloat(bVal) || 0;
        } else {
          aVal = aVal.toLowerCase();
          bVal = bVal.toLowerCase();
        }

        if (aVal < bVal) return orderByDirection === 'asc' ? -1 : 1;
        if (aVal > bVal) return orderByDirection === 'asc' ? 1 : -1;
        return 0;
      });

      $tbody.empty().append($rows);
    });

    $(document).on('click', '.show-details-button', function () {
      const productId = $(this).attr('data-product-id');
      const parentTr = $(this).closest('tr');
      const detailContainer = parentTr.next('.menu-product-products-container');
      const showIconDiv = $(this).closest('tr').find('.show-detail-icon');
      const hideIconDiv = $(this).closest('tr').find('.hide-detail-icon');

      if (detailContainer.length > 0) {
        detailContainer.remove();
        showIconDiv.toggleClass('d-none');
        hideIconDiv.toggleClass('d-none');
        return;
      }

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/supply-list/get-menu-product-products',
        data: {
          product_id: productId,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            parentTr.after(
              '<tr class="menu-product-products-container"><td colspan="100%" style="border:none">' +
                data.html +
                '</td></tr>'
            );
            setTimeout(() => {
              showIconDiv.toggleClass('d-none');
              hideIconDiv.toggleClass('d-none');
            }, 200);
          }
        })
        .fail(function (data) {
          if (data.responseJSON.redirect_url) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (data.error) {
            return alert(data.error);
          }
        });
    });

    $(document).on('click', '.print-supply-list', function () {
      const startDate = $('#start-date').val();
      const endtDate = $('#end-date').val();
      const locationId = $('#location-id').val();

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/printer/supply-list',
        data: {
          start_date: startDate,
          end_date: endtDate,
          location_id: locationId,
        },
      }).done(function (data) {
        if (data && data.html) {
          if ($('#printer-list-modal').length) {
            $('#printer-list-modal').remove();
          }
          $('#content').append(data.html);
          $('#printer-list-modal').modal('show');
        }
      });
    });

    $(document).on('submit', '#supply-list-filter-form', function (e) {
      e.preventDefault();

      const form = $(this);
      const formData = {};
      form.serializeArray().forEach(function (item) {
        if (item.value && item.value.trim() !== '') {
          formData[item.name] = item.value;
        }
      });

      formData.page = page;
      formData.orderBy = orderBy;
      formData.orderByDirection = orderByDirection;

      getSupplyList(formData);
    });

    function getSupplyList(formData) {
      $.ajax({
        type: 'POST',
        url: '/api/v1/private/supply-list/search',
        data: formData,
      })
        .done(function (data) {
          if (data.html) {
            $('.supply-list-view-content').empty();
            $('.supply-list-view-content').html(data.html);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            showToast({
              title: 'Feil!',
              message: data.responseJSON.error_message,
              type: 'error',
              duration: 5000,
            });
          }
        });
    }
  }
});
